module.exports = __webpack_public_path__ + "img/infj-selected.7a6ae051.png";